
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/knock",
      function () {
        return require("private-next-pages/destinations/knock.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/knock"])
      });
    }
  